import { render, staticRenderFns } from "./EditorHeader.vue?vue&type=template&id=6cb207c0&scoped=true&"
import script from "./EditorHeader.vue?vue&type=script&lang=js&"
export * from "./EditorHeader.vue?vue&type=script&lang=js&"
import style0 from "./EditorHeader.vue?vue&type=style&index=0&id=6cb207c0&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6cb207c0",
  null
  
)

export default component.exports